import { render, staticRenderFns } from "./CalculateLoanAmountPopup.vue?vue&type=template&id=35b5282a&scoped=true"
import script from "./CalculateLoanAmountPopup.vue?vue&type=script&lang=js"
export * from "./CalculateLoanAmountPopup.vue?vue&type=script&lang=js"
import style0 from "./CalculateLoanAmountPopup.vue?vue&type=style&index=0&id=35b5282a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b5282a",
  null
  
)

export default component.exports